export default __webpack_public_path__ + "static/media/sports19.a5c055ea.jpg";